import styled from "styled-components";

const OuterContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  zindex: 99;
  background-color: rgb(255, 254, 239);
  height: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #253569;
  font-weight: 400;
  font-family: Karla;
  font-size: 1.1em;
  // background-color: red;
  // padding-top: 30px;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 90%;

  @media (max-width: 460px) {
    align-items: center;
    flex-direction: column;
  }
`;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: end;

  @media (max-width: 460px) {
    align-items: center;
  }
`;

const Header = () => {
  return (
    <OuterContainer>
      <InnerContainer>
        <strong>London, UK</strong>
        <div>
          <ContactContainer>
            <strong>
              <a
                style={{ color: "#253569", textDecoration: "none" }}
                href="mailto:ciannamcanning@gmail.com"
              >
                ciannamcanning@gmail.com
              </a>
            </strong>
            <strong>
              <a
                style={{ color: "#253569", textDecoration: "none" }}
                href="tel:+447490116558"
              >
                +44 (0) 7490 116558
              </a>
            </strong>
          </ContactContainer>
        </div>
      </InnerContainer>
    </OuterContainer>
  );
};

export default Header;
